// Use this controller for modals not rendered from AJAX calls,
// like: file upload modal
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['modal'];

  connect() {
    window.modalManager = this;

    this._onOpen  = (e) => this.onOpenRequest(e);
    this._onClose = (e) => this.onCloseRequest(e);

    this.element.addEventListener('local-modal-manager:open', this._onOpen);
    this.element.addEventListener('local-modal-manager:close', this._onClose);
  }

  disconnect() {
    this.element.removeEventListener('local-modal-manager:open', this._onOpen);
    this.element.removeEventListener('local-modal-manager:close', this._onClose);
  }

  open(event)  { const id = event.params.id; this._showById(id); }
  close(event) { const id = event.params.id; this._hideById(id); }

  onOpenRequest(e)  { this._showById(e.detail?.id); }
  onCloseRequest(e) { this._hideById(e.detail?.id); }

  closeAll() { this.modalTargets.forEach((m) => this.hideModal(m)); }

  closeIfBackdrop(event) {
    if (event.target.dataset.modalBackdrop !== undefined) {
      this._hideById(event.target.id);
    }
  }

  _showById(id) {
    if (!id) return;
    const modal = this.modalTargets.find((el) => el.id === id);
    if (modal) this.showModal(modal);
    else console.warn('Modal not found:', id);
  }
  _hideById(id) {
    if (!id) return;
    const modal = this.modalTargets.find((el) => el.id === id);
    if (modal) this.hideModal(modal);
  }

  showModal(modal) {
    modal.classList.remove('hidden');
    modal.classList.add('block', 'md:flex');
  }
  hideModal(modal) {
    modal.classList.remove('block', 'md:flex');
    modal.classList.add('hidden');
  }
}
